import React, { useState } from 'react';
/**
 * @description:This function will add Button Component .
 * @author: SAR TECH EASY
 * @param {*}
 * @function Button
 * @date : 21-08-2025
 */

function InnerLoader(props) {
  const { state } = props || {};
  const [className] = useState(props.className);

  return (
    <div className={`layoverLoader ${className}`}>
      <div className="pageInner">
        <div className="loaderIcon"></div>
      </div>
    </div>
  );
}

export default InnerLoader;
